import Source from "./From/Source";
import Customer from "./To/Customer";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Invoice from "./Invoice";
import Payment from "./Payment";
import TillBasedPos from "./Pos/TillBasedPos";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import Discount from "./Discount";
import Buttons from "../Elements/Buttons";
import connect from "react-redux/es/connect/connect";
import Box from "../../../layout/Box";
import List from "./List";
import PoolList from "./Picking/PoolList";
import VatRate from "./VatRate";

export class SalesForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        if (!(this.props.till || {}).id) {
            return <Box header="Hiba" theme="danger">
                Kérlek jelentkezz be egy kasszába!
            </Box>;
        }
        return <Fragment>
                <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
                <Editor
                    theme="default"
                    footer={<Fragment>
                        <Buttons {...componentProps} />
                    </Fragment>}
                >
                    {
                        props.values.id && <form onSubmit={props.handleSubmit}>
                            <div className="row form-row">
                                <TillBasedPos {...componentProps} />
                            </div>
                            <div className="row form-row">
                                <div className="col-md-4">
                                    <Source {...componentProps} />
                                </div>
                                <div className="col-md-4">
                                    <Customer {...componentProps} />
                                </div>
                                <div className="col-md-4">
                                    <Target {...componentProps} />
                                </div>
                            </div>
                            <div className="row form-row">
                                <Shipping {...componentProps} />
                            </div>
                            <Invoice {...componentProps} />
                            <div className="row form-row">
                                <Payment {...componentProps} />
                            </div>
                            <Comment {...componentProps} />
                            <div className="row form-row">
                                <div className="col-md-6">
                                    <Discount {...componentProps} />
                                </div>
                                <div className="col-md-6">
                                    <VatRate {...componentProps} />
                                </div>
                            </div>
                            <PoolList {...componentProps} control={{visible: false}} />
                        </form>
                    }
                </Editor>
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})(SalesForm);